import { z } from "zod";
import { Role } from "../../shared/constants/roles.js";

const AssignableRoles = [
  Role.Developer,
  Role.Analyst,
  Role.Operator,
  Role.Customer,
  Role.CustomerOperator,
] as const;

export const AssignableRoleSchema = z.enum(AssignableRoles);
export type AssignableRole = z.infer<typeof AssignableRoleSchema>;

export const AssignRoleSchema = z
  .object({
    role: AssignableRoleSchema,
  })
  .strict();

export type AssignRoleBody = z.infer<typeof AssignRoleSchema>;

export const RemoveRoleSchema = z
  .object({
    role: AssignableRoleSchema,
  })
  .strict();

export type RemoveRoleBody = z.infer<typeof RemoveRoleSchema>;
